import type { Action } from '@reduxjs/toolkit';

import type { LiveStreamPreferences } from './types';
import type { ReduxAction } from 'app/redux/types';

import type { RecordOfLiveStreamEntry } from './records';
import { liveStreamEntry } from './records';
import type { LiveStreamsDAO } from './types/backend/liveStream';

// ---

export const APPLY_LIVE_STREAM_ENTRIES = 'LIVE_STREAM:APPLY_ENTRIES';

export type ApplyLiveStreamEntries = ReduxAction<
  typeof APPLY_LIVE_STREAM_ENTRIES,
  RecordOfLiveStreamEntry[]
>;

export const applyLiveStreamEntries = (streams: LiveStreamsDAO): ApplyLiveStreamEntries => ({
  type: APPLY_LIVE_STREAM_ENTRIES,
  payload: streams.map((stream) => liveStreamEntry(stream)),
});

// ---

export const SELECT_STREAM = 'LIVE_STREAM:SELECT_STREAM';

export type SelectStream = ReduxAction<typeof SELECT_STREAM, {
  matchId: number;
}>;

export const selectStream = (matchId: number): SelectStream => ({
  type: SELECT_STREAM,
  payload: { matchId },
});


export const SELECT_STREAM_WITH_AUTOPLAY = 'LIVE_STREAM:SELECT_STREAM_WITH_AUTOPLAY';

export type SelectStreamWithAutoplay = ReduxAction<typeof SELECT_STREAM_WITH_AUTOPLAY, {
  matchId: number;
}>;

export const selectStreamWithAutoplay = (matchId: number): SelectStreamWithAutoplay => ({
  type: SELECT_STREAM_WITH_AUTOPLAY,
  payload: { matchId },
});


export const SET_DEFAULT_STREAM = 'LIVE_STREAM:SET_DEFAULT_STREAM';

export type SetDefaultStream = Action<typeof SET_DEFAULT_STREAM>;

export const setDefaultStream = (): SetDefaultStream => ({
  type: SET_DEFAULT_STREAM,
});

// ---

export const CLOSE_LIVE_STREAM = 'LIVE_STREAM:LIVE_STREAM_CLOSE';

export type CloseLiveStream = Action<typeof CLOSE_LIVE_STREAM>;

export const closeLiveStream = (): CloseLiveStream => ({
  type: CLOSE_LIVE_STREAM,
});

// ---

export const TOGGLE_MUTED_STATE = 'LIVE_STREAM:LIVE_STREAM_TOGGLE_MUTED';

export type ToggleMutedState = ReduxAction<typeof TOGGLE_MUTED_STATE, {
  muteState: boolean;
}>;

export const toggleMutedState = (muteState: boolean): ToggleMutedState => ({
  type: TOGGLE_MUTED_STATE,
  payload: { muteState },
});

// ---

export const SET_PIP_MODE = 'LIVE_STREAM:SET_PIP_MODE';

export type SetPipMode = ReduxAction<typeof SET_PIP_MODE, {
  pipMode: boolean;
}>;

export const setPipMode = (pipMode: boolean) => ({
  type: SET_PIP_MODE,
  payload: { pipMode },
});

// ---

export const SET_STORED_PREFERENCES = 'LIVE_STREAM:SET_STORED_PREFERENCES';

export type SetStoredPreferences = ReduxAction<typeof SET_STORED_PREFERENCES, {
  preferences: LiveStreamPreferences;
}>;

export const setStoredPreferences = (preferences: LiveStreamPreferences): SetStoredPreferences => ({
  type: SET_STORED_PREFERENCES,
  payload: { preferences },
});
